export const hasCharacters = (value) => /\S/.test(value || '');
